"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.envNames = void 0;
function envNames(env, names = []) {
    while (env["@kind"] !== "EnvNull") {
        names.unshift(env.name);
        env = env.rest;
    }
    return names;
}
exports.envNames = envNames;
//# sourceMappingURL=envNames.js.map